import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useGetAllInvestigations } from '@/application/services/investigation.service'
import { useGetLeadGroups } from '@/application/services/lead.service'
import { Card, CardContent, CardHeader, CardTitle } from '@/ui/components/common/Card'
import { ListSkeleton } from './ListSkeleton'

/**
 * Sidebar card listing the user's investigations (capped at 10) with a
 * lead-count badge per row and a shortcut to create a new investigation.
 */
export function RecentInvestigationsSection() {
  const { t } = useTranslation()
  const { data: investigations, isLoading } = useGetAllInvestigations()
  const { data: leadGroups } = useGetLeadGroups()

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <span>{t('admin.dash_your_investigations')}</span>
          <Link to="/manage/investigations/create" className="text-sm text-primary hover:underline">
            {t('admin.dash_add_investigation')}
          </Link>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <ListSkeleton />
        ) : investigations && investigations.length > 0 ? (
          <ul className="space-y-3">
            {investigations.slice(0, 10).map((investigation) => (
              <li key={investigation.id}>
                <Link
                  to="/manage/investigations/$id/edit"
                  params={{ id: investigation.id }}
                  className="block p-3 rounded-lg hover:bg-muted/50 transition-colors"
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-medium">{investigation.name}</p>
                      <p className="text-sm text-muted-foreground">
                        {investigation.investigationId}
                      </p>
                    </div>
                    <span className="text-sm text-muted-foreground">
                      {leadGroups?.find((group) => group.investigation.id === investigation.id)
                        ?.leads.length || 0}{' '}
                      leads
                    </span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-muted-foreground">{t('admin.dash_no_investigations')}</p>
        )}
      </CardContent>
    </Card>
  )
}
